import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { ARConstants } from '../../../../cirabooks-module/_constants/cb-ar-constants';

export class JournalEntryItemResultDto {
    glJournalItemId: number;

    glJournalId: number;

    glAccountNumber: string;
    glAccountDisplayText: string;
    subCategory: string;
    debitOrCredit: string;
    amount: number;

    description: string;
    @Type(() => DimensionOptionResultDto)
    dimensions: DimensionOptionResultDto[];

    // transient veriables
    debit: number;
    credit: number;

    getDebitCreditAmount(): void {
        if (this.debitOrCredit === ARConstants.DEBIT_CODE) {
            this.debit = this.amount;
        } else if (this.debitOrCredit === ARConstants.CREDIT_CODE) {
            this.credit = this.amount;
        }
    }
}
